import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from 'reactstrap';
import { AUTH0_REDIRECT_URL } from '../../constants';

const LogoutButton = (props) => {
  const { logout } = useAuth0();

  return (
    <Button onClick={() => logout({ returnTo: AUTH0_REDIRECT_URL })} {...props}>
      Logout
    </Button>
  );
};

export default LogoutButton;